import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Portal } from "@air/primitive-portal";
import { ContentCollectionRemoveItemsButton } from "~/components/ContentCollection/ContentCollectionRemoveItemsButton";
import { ContentCollectionSelectAllButton } from "~/components/ContentCollection/ContentCollectionSelectAllButton";
import { ContentCollectionSubmitButton } from "~/components/ContentCollection/ContentCollectionSubmitButton";
import { ContentCollectionUploadMoreButton } from "~/components/ContentCollection/ContentCollectionUploadMoreButton";
export const ContentCollectionMobileActionBar = ()=>{
    return /*#__PURE__*/ _jsx(Portal, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "fixed inset-x-0 bottom-0 flex flex-col gap-2 border-t border-grey-5 bg-grey-1 p-4",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ _jsx(ContentCollectionSelectAllButton, {}),
                                /*#__PURE__*/ _jsx(ContentCollectionRemoveItemsButton, {})
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex items-center gap-2",
                            children: /*#__PURE__*/ _jsx(ContentCollectionUploadMoreButton, {})
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(ContentCollectionSubmitButton, {})
            ]
        })
    });
};
